module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[72]559.470aed2.woff2";